import React, { PureComponent } from 'react';
import { message } from 'antd';
import { services } from '@comall-backend-builder/core';
// import { DesignPage } from '@comall-backend-builder/design-components-basis';
import { DesignPage } from '../../design_page';
import { DESIGN_PAGE_LINK_TYPES_LIST } from '../../constants/page-design';
import { errorHandle } from '../../services';

const api = services.api;
/**
 * 可视化-页面模板设计
 */
export class PageTemplateDesign extends PureComponent<any> {
    loadProfile = () => {
        const {
            params: { id },
        } = this.props;
        return api
            .get(
                { id },
                {
                    apiPath: '/template/:id',
                }
            )
            .catch(errorHandle);
    };

    onSave = (data: any) => {
        api.put(data, { apiPath: '/template/:id' })
            .then(() => {
                message.success('保存成功');
                services.navigation.goBack();
            })
            .catch(errorHandle);
    };
    onCancel = () => {
        services.navigation.goBack();
    };
    render() {
        const {
            client,
            params: { id },
        } = this.props;
        const submitProps = {
            onClick: this.onSave,
        };
        const cancelProps = {
            onClick: this.onCancel,
        };
        return (
            <DesignPage
                urlId={id}
                client={client}
                loadProfile={this.loadProfile}
                submit={submitProps}
                cancel={cancelProps}
                verbose={true}
                isTemplate={true}
                linkTypes={DESIGN_PAGE_LINK_TYPES_LIST}
                uploadAction={`${ENV.API_ROOT}/images`}
            ></DesignPage>
        );
    }
}
